<template>
  <button
    v-tooltip="title"
    class="ms-button btn"
    :class="[
      type,
      text ? '' : 'only-icon',
      radius ? 'btn-radius' : '',
      hasBorder ? '' : 'btn-border-none',
      disabled ? 'disabled-icon' : '',
    ]"
    :disabled="disabled || processing"
    @focus="() => $emit('focus')"
    @keydown="(e) => $emit('keydown', e)"
  >
    <!-- Loading -->
    <transition name="ms-fade">
      <div
        v-if="processing"
        class="ms-button-loading"
      >
        <div class="loading-svg">
          <div class="effects" />
        </div>
      </div>
    </transition>

    <div
      v-if="leftIcon"
      :class="['icon16 icon left', leftIcon, disabled ? 'disabled-icon' : '']"
    >
      &nbsp;
    </div>
    <div
      v-if="text"
      class="text"
      :class="[{ 'pl-0': leftIcon, 'pr-0': rightIcon }]"
    >
      {{ text }}
    </div>
    <div
      v-if="rightIcon"
      :class="['icon16 icon right', rightIcon, disabled ? 'disabled-icon' : '']"
    />

    <div
      v-if="$slots.default"
      class="ms-button-text ms-button--text flex align-center"
    >
      <slot />
    </div>
  </button>
</template>

<script>
import { defineComponent, computed, getCurrentInstance, onMounted, watch, ref } from 'vue';

export default defineComponent({
  name: 'MsButton',
  props: {
    //Tooltip hiển thị
    title: {
      type: String,
      default: null,
    },
    //Text hiển thị
    text: {
      default: null,
      type: String,
    },
    //Icon trái
    leftIcon: {
      default: null,
      type: String,
    },
    //Icon phải
    rightIcon: {
      default: null,
      type: String,
    },
    //Loại button gồm 3 loại primary/secondary/danger để hiện thị style tương ứng
    type: {
      default: 'primary',
      type: String,
    },
    // Trạng thái button disabled
    disabled: {
      default: false,
      type: Boolean,
    },
    // Cờ đánh dấu đang xử lý
    processing: {
      default: false,
      type: Boolean,
    },
    radius: {
      default: false,
      type: Boolean,
    },
    //border hiển thị
    hasBorder: {
      default: false,
      type: Boolean,
    },
  },
  emits: ['keydown', 'focus'],
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();

    /**
     * Hủy lan rộng event
     * HTHIEP 09.02.2022
     */
    const cancelEvent = (e) => {
      if (e) {
        if (typeof e.preventDefault === 'function') {
          e.preventDefault();
        }

        if (typeof e.stopPropagation === 'function') {
          e.stopPropagation();
        }

        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
      }
    };

    /**
     * Xử lý thò các event ra ngoài component
     * HTHIEP 09.02.2022
     */
    const listeners = computed(() => {
      const me = this;
      return {
        click: (event) => {
          //hủy lan rộng event
          cancelEvent(event);

          let deplay = window._appConfig.buttonClickDeplayMilliseconds;
          if (deplay && deplay > 0) {
            if (me._clicking) {
              return;
            }

            me._clicking = true;
            setTimeout(() => {
              delete me._clicking;
            }, deplay);
          }
          me.$emit('click', event);
        },
        mousedown: (event) => {
          //hủy lan rộng event
          cancelEvent(event);
        },
        keydown: (event) => {
          //hủy lan rộng event
          cancelEvent(event);
          //trigger ra ngoài component
          emit('keydown', event);
        },
        focus: (event) => {
          //hủy lan rộng event
          cancelEvent(event);
          //trigger ra ngoài component
          emit('focus', event);
        },
      };
    });

    return { listeners };
  },
});
</script>
<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/components/MsButton.scss';
@import '@/assets/scss/btn.scss';
</style>
